import { Component, OnInit } from '@angular/core';
import { TagNcaseManagementService } from '../../services/TagNcaseManagement.service';
import { HaHeaderViewServiceService } from '../../services/HaHeaderView.service';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
import { ErrorModel } from '../../../../shared/models/Error.model';

@Component({
  selector: 'app-ha-template-sharing',
  templateUrl: './ha-template-sharing.component.html',
  styleUrls: ['./ha-template-sharing.component.css']
})
export class HaTemplateSharingComponent implements OnInit {
  doctors: any[];
  templates: any[];

  elementSlide: HTMLElement;
  elementMain: HTMLElement;
  usersWithTemplate: any[];
  currentTemplate: string = '';
  currentDoctor: string = '';
  showOverlayTemplate: boolean;
  shareListLoader: boolean;
  searchTerm: string = '';
  assignedListShow: boolean;
  listView: boolean = false;
  templateName: string = '';
  viewId: boolean;
  searchTermDoctor: string = '';
  templateCount: number = 0;
  mainViewError = new ErrorModel();
  shareError = new ErrorModel();
  templateError = new ErrorModel();
  shareLoader: boolean;

  constructor(private _service: TagNcaseManagementService, private viewservice: HaHeaderViewServiceService) {
  }

  ngOnInit() {
    this.getDoctors();
  }

  closeNav() {
    for (let doc of this.doctors) {
      doc.border = "";
      doc.borderBottom = "";
    }
    this.elementSlide = document.getElementById('slideDiv') as HTMLElement;
    this.elementSlide.style.marginRight = "-105%";
    this.elementSlide.style.opacity = "0";

    this.elementMain = document.getElementById('main_content') as HTMLElement;
    this.elementMain.style.width = "100%";
  }
  //getting template associated with particular user

  showTemplate(id, index) {
    this.shareListLoader = true;
    this.templateError.display = false;
    this.templateCount = 0;
    this.templates = [];
    //changing background of list item
    this.elementSlide = document.getElementById('slideDiv') as HTMLElement;
    this.elementSlide.style.marginRight = "0px";
    this.elementSlide.style.opacity = "1";
    this.elementMain = document.getElementById('main_content') as HTMLElement;
    this.elementMain.style.width = "70%";
    for (let doctor of this.doctors) {
      doctor.border = "";
      doctor.borderBottom = "";
    }

    this.doctors[index].border = "2px solid #0969c9";
    this.doctors[index].borderBottom = "2px solid #0969c9";
    //
    if (id != null || id != undefined || id != '') {
      this._service.getTemplates(id).subscribe(
      (data: any) => {
        this.templateCount = data["Count"];
        this.templates = data["templates"];
        this.currentDoctor = id;
        // this.shareListLoader = false;
        if (this.templates.length <= 0) {
          this.assignedListShow = true;
        } else {
          this.assignedListShow = false;
          for (let i = 0; i < this.templates.length; i++) {
            this.templates[i]["CreatedTDate"] = new Date(this.templates[i]["createDate"]);
          }
          this.templates.forEach(i => {
            var fmDate = new Date(i.createDate);
            i.fmDate = fmDate.getDate() + "-" + (1 + parseInt(fmDate.getMonth().toString())) + "-" + fmDate.getFullYear();
          });
        }
      },
      (error) => {
        this.templateError.error = error;
        this.templateError.display = true;

      }).add(() => {
        this.shareListLoader = false;
      });
    }
  }

  //getting list of all doctors

  getDoctors() {
    this.showOverlayTemplate = true;
    this.mainViewError.display = false;
    this._service.getDoctors().subscribe((data: any[]) => {
      this.doctors = data;
      this.viewId = this.viewservice.getViewId();
      this.listView = this.viewId;
    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;
    }).add(() => {
      this.showOverlayTemplate = false;
    });
  }

  //getting data on template click

  onTemplateClick(id, serverPath, name) {
    this.shareError.display = false;
    this.shareLoader = true;
    this.templateName = name;
    this.currentTemplate = id;
    this.usersWithTemplate = [];
    this._service.getEaUsersWithTemplates(this.currentDoctor, serverPath).subscribe(
    (data: any[]) => {
    this.usersWithTemplate = data;
    },
    (error) => {
      this.shareError.error = error;
      this.shareError.display = true;
    }).add(() => {
      this.shareLoader = false;
    });
  }

  //code for sharing template

  shareTemplate(id) {
    this._service.shareTemplate(id, this.currentTemplate, this.templateName).subscribe(
    (data) => {

      AlertMessages.Show('Success', 'Shared with selected user', AlertType.Success);
    },
    (error) => {
      AlertMessages.Show('Failed', 'Could not share!', AlertType.Error);
    });
  }

  closeShare() {
    this.templateName = "";
  }

}
